import { Button, Typography } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Alert, AlertTitle } from '@material-ui/lab'
import { useEffect, useState } from 'react'
import { Error, Identifier, LinearProgress, useNotify, useQueryWithStore } from 'react-admin'

import { checkJobFeasibility, checkLoadFeasibility } from '../../api/jobs'

export const bookingTypeDialogText = {
  standard: 'standard',
  instant: 'instant',
}

export const bookingTypeLabelText = {
  standard: 'Standard book',
  instant: 'Instant book',
}

export const BookingType = {
  standard: 'STANDARD_BOOK',
  instant: 'INSTANT_BOOK',
}

export const handleFlags = (props: any) => {
  const flags_obj = JSON.parse(JSON.stringify(props))
  var tmp_flags: any = []
  var counter = 0
  flags_obj.forEach((flag: any) => {
    const key_flag_title = 'flag_title' + String(counter)
    const key_flag_message = 'flag_message' + String(counter)
    tmp_flags.push(
      <Typography component="span" key={key_flag_title} display="block">
        &bull; {flag.type}: {flag.code}
      </Typography>
    )
    tmp_flags.push(
      <Typography component="span" key={key_flag_message} display="block">
        {' '}
        &rarr; {flag.message}
      </Typography>
    )
    counter++
  })
  return tmp_flags
}

const FeasibilityMessage = (props: any) => {
  const [feasible, setFeasible] = useState(true)
  const [flags, setFlags] = useState('')
  const [loading, setLoading] = useState(true)
  const [feasiblityStatus, setFeasiblityStatus] = useState('')
  const notify = useNotify()
  const feasibility_function =
    props.booking_type === bookingTypeDialogText.standard ? checkJobFeasibility : checkLoadFeasibility

  useEffect(() => {
    //feasibilty check
    notify('Loading Feasibility Check results', { type: 'info' })
    let payload = {
      assigned_to: props.user,
    }
    feasibility_function(props.id, payload).then((response) => {
      setLoading(false)
      setFeasible(response.is_feasible)
      setFlags(handleFlags(response.flags))
      setFeasiblityStatus(feasible ? 'feasible' : 'not feasible')
    })
  }, [feasible, notify, props, feasibility_function])

  return (
    <span>
      {loading ? (
        <LinearProgress />
      ) : feasible ? (
        <span>
          This load is <strong>{feasiblityStatus}</strong>.<br />
        </span>
      ) : (
        <span>
          <span>
            This load is <strong>{feasiblityStatus}</strong> for the following reasons:
            <br />
          </span>
          <Alert variant="outlined" severity="info">
            <AlertTitle>
              <strong>Feasibility Check Flags</strong>
            </AlertTitle>
            {flags}
          </Alert>
        </span>
      )}
    </span>
  )
}

type DialogTextProps = {
  id: Identifier
  load: any
  user: any
  booking_type: string
  showFC: boolean
}

const createDialogText = ({ id, load, user, booking_type, showFC }: DialogTextProps) => {
  let action = booking_type === bookingTypeDialogText.standard ? 'approved' : 'booked'
  return (
    <span>
      <span>
        This {load.source} load will be {action} for{' '}
        <b>
          {user.first_name} {user.last_name}
        </b>{' '}
        of team <b>{user.team.name}</b> via {booking_type} book.
      </span>
      {showFC && <FeasibilityMessage id={id} load={load} user={user.id} booking_type={booking_type} />}
      <span>
        <br />
        Are you sure?
      </span>
    </span>
  )
}

const getDialogTitleBodyText = ({ id, load, user, booking_type, showFC }: DialogTextProps) => {
  const title =
    booking_type === BookingType.standard ? bookingTypeLabelText.standard : bookingTypeLabelText.instant
  const body_booking_type =
    booking_type === BookingType.standard ? bookingTypeDialogText.standard : bookingTypeDialogText.instant
  const dialogTextObj: DialogTextProps = {
    id: id,
    load: load,
    user: user,
    booking_type: body_booking_type,
    showFC: showFC,
  }
  return {
    title: title,
    body: createDialogText(dialogTextObj),
  }
}

export const BookApproveLoadButton = (props: any) => {
  const [open, setOpen] = useState(false)
  const { id, load, assignedTo, bookingType } = props
  const { loaded, error, data } = useQueryWithStore({
    type: 'getOne',
    resource: 'users',
    payload: { id: assignedTo },
  })
  if (!loaded || !data) return null
  if (error) return <Error error={error} />
  let showFC = true
  let action = bookingType === BookingType.standard ? 'Approve' : 'Book'
  if (bookingType === BookingType.standard) {
    if (id === load.id) {
      showFC = false
      action = 'Book'
    }
  }
  const dialogTextObj: DialogTextProps = {
    id: id,
    load: load,
    user: data,
    booking_type: bookingType,
    showFC: showFC,
  }
  const dialogTitleBodyText = getDialogTitleBodyText(dialogTextObj)
  return (
    <>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        {action} Load
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{dialogTitleBodyText.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogTitleBodyText.body}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button type="submit" variant="contained" color="primary" onClick={props.onSubmit}>
            Confirm
          </Button>
          <Button color="secondary" onClick={() => setOpen(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
